










































import S3Image from '@/components/S3Image.vue';

import AnimalSubscribe from '@/modules/guest/animals/_components/AnimalSubscribe.vue';

import {Component, Vue, Prop} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';

@Component({
  components: {
    S3Image,
    AnimalSubscribe,
  },
})
export default class List extends Vue {
  private complete: boolean = false;
  private loading: boolean = false;

  @Prop({type: String, default: ''}) private id!: string;

  @Action('guest/animals/readOne') private readAnimal!: any;
  @Getter('guest/animals/one') private animal!: any;

  private mounted() {
    this.loading = true;
    this.readAnimal({id: this.id})
      .then(() => {
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });
  }

  private getPostText(description: string) {
    return description ? description.replace(/\n/gm, '</br>') : '';
  }
}
